export const nl = {
  title: 'Landbedekking 2015',
  subtitle: 'ESA/UCLouvain, 2015',
  download_data: 'http://maps.elie.ucl.ac.be/CCI/viewer/download.php',
  learn_more: 'http://maps.elie.ucl.ac.be/CCI/viewer/download/ESACCI-LC-Ph2-PUGv2_2.0.pdf',
  content: [
    {
      label: 'Functie',
      value: 'Toont de wereldwijde verdeling van de landbedekking in 2015',
    },
    {
      label: 'Resolutie',
      value: '300 × 300 meter',
    },
    {
      label: 'Geografische dekking',
      value: 'Globaal',
    },
    {
      label: 'Bron',
      value: '© ESA Climate Change Initiative - Landbedekking onder leiding van UCLouvain (2017)',
    },
    {
      label: 'Frequentie',
      value: 'Jaarlijks',
    },
    {
      label: 'Datum van inhoud',
      value: '2015',
    },
    {
      label: 'Waarschuwingen',
      value:
        'Een volledige nauwkeurigheidsbeoordeling is verkrijgbaar bij de CCI. Over het algemeen worden landbedekkingsklassen zoals door regen gevoede en geïrrigeerde akkers, breedbladig groenblijvend bos, stedelijke gebieden, kale gebieden, waterlichamen en permanente sneeuw vrij nauwkeurig in kaart gebracht. Aan de andere kant kunnen klassen zoals korstmossen en mossen, schaarse vegetatie en overstroomd bos met zoet water worden aangetast door fouten.\n\nDe gegevenskwaliteit verschilt per regio, met name als het gaat om de dekking van MERIS-beelden voor het maken van de basislijnkaart. Gebieden met minder dekking zijn onder meer het westelijke deel van het Amazonebekken, Chili en het zuidelijke deel van Argentinië, het westelijke deel van het Congobekken en de Golf van Guinee, het oostelijke deel van Rusland en de oostkust van China en Indonesië.',
    },
    {
      label: 'Licentie',
      value: 'http://maps.elie.ucl.ac.be/CCI/viewer/download.php',
    },
  ],
  overview: {
    label: 'Overzicht',
    value:
      'Deze dataset (versie 2.07) is gemaakt als onderdeel van het Climate Change Initiative (CCI), een initiatief van de Europese Ruimtevaartorganisatie ESA om consistente, wereldwijde gegevens voor de lange termijn te creëren ten behoeve van klimaatmodellering. Het CCI Land Cover-project levert van 1992 tot 2015 op jaarbasis consistente wereldwijde landbedekkingskaarten met een ruimtelijke resolutie van 300 m. Het Global Forest Watch-platform geeft alleen de gegevens over landbedekking in 2015 weer.\n\nOm de consistentie van jaar tot jaar te garanderen, worden landbedekkingskaarten voor elk jaar afgeleid van een enkele basiskaart van de bodembedekking. De basislijnkaart is gemaakt met behulp van het volledige record van MERIS-afbeeldingen van 2003 tot 2012, met behulp van classificatie zonder toezicht en een machine learning-algoritme over meerdere jaren aan beelden. Veranderingen worden vervolgens gedetecteerd tussen individuele jaren met een resolutie van 1 km, met behulp van AVHRR-gegevens van 1992 tot 1999, SPOT-VGT-gegevens van 1999 tot 2013 en PROVA-V-gegevens van 2014 en 2015. Veranderingen moeten gedurende twee opeenvolgende jaren consistent zijn om te kunnen worden meegeteld, met uitzondering van bosveranderingen in 2014 en 2015 waarvan wordt aangenomen dat ze goed zijn gedetecteerd. De veranderingen van 1 km worden vervolgens gecombineerd met de basiskaart van de landbedekking en afgebakend tot 300 meter vanaf 2004 (wanneer MERIS- en PROVA-V-gegevens beschikbaar zijn).\n\nDe resulterende gegevens hebben in totaal 22 wereldwijde landbedekkingsklassen. Omwille van een betere visualisatie toont Global Forest Watch alleen een reeks vereenvoudigde klassen, gebaseerd op het IPCC (landbouw, bos, grasland, wetland, nederzetting, struikgewas, schaarse vegetatie, kale oppervlakte, water en permanent ijs en sneeuw). De volledige set lessen en de jaarlijkse landbedekkingskaarten vanaf 1992 zijn beschikbaar op de ESA/CCI-viewer.',
  },
  citation: {
    label: 'Aanhaling',
    value:
      'ESA Climate Change Initiative, Land Cover - led by UC Louvain. “2015 global land cover.” Land Cover CCI Product User Guide Version 2. Tech. Rep. (2017). Available at: maps.elie.ucl.ac.be/CCI/viewer/download/ESACCI-LC-Ph2-PUGv2_2.0.pdf. Accessed through Global Forest Watch on 14/02/2025. www.globalforestwatch.org.',
  },
};
